import { all } from 'redux-saga/effects';
import { API } from './../services';

/* ------------- Types ------------- */

/* ------------- Sagas ------------- */
import authSaga from './auth/saga';
import timesheetSaga from './timesheet/saga';
import employeesSaga from './employees/saga';
import jobCodes from './jobcodes/saga';
import task from './task/saga';
import phaseCodes from './phasecodes/saga';
import users from './users/saga';
import content from './contentRedux/saga';

/* ------------- API ------------- */
const api = API.create();

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
  yield all([
    // some sagas only receive an action
    // takeLatest(StartupTypes.STARTUP, startup),

    ...authSaga(api),
    ...timesheetSaga(api),
    ...employeesSaga(api),
    ...jobCodes(api),
    ...task(api),
    ...phaseCodes(api),
    ...users(api),
    ...content(api),
  ]);
}
